module.exports = __webpack_public_path__ + "media/images/referrals/gold-stars-5-44db3019841e94fce70fdc729d693533.svg";